export default "__VITE_ASSET__CgpdP4ZJ__"